import { useLang } from '../i18n';
import { Btn } from '../design/ui';
import { tarikhMasaPapar } from '../utils/tarikhPapar';

// Satu Flow, satu browser pada satu masa (2026-10-03, keputusan user) — Jenis 1 sahaja.
// Peraturannya di server (functions/flowSessionBrowser.js). Halaman ini hanya:
//   • papar notis bila extension menjawab ACTIVE_ELSEWHERE semasa Open Flow, dan
//   • beri pelanggan SENDIRI butang "Pindah ke browser ini" (tiada admin, tiada rampasan senyap).
// Pindah = services/flowBrowserService.js lepasBrowser(), kemudian Open Flow biasa
// (FlowCustomerView.pindah) yang menuntut tempat itu untuk browser ini. Browser lama ditutup
// oleh extensionnya sendiri pada semakan berikutnya — pelanggan di browser BAHARU tidak menunggu itu.
// seenAt: bila browser yang memegang Flow kali terakhir melapor (ms) — dari /customer/overview.
export default function FlowBrowserLain({ seenAt, busy, onMove }) {
    const { t, lang } = useLang();
    return <div className="fc-browser-lain" role="status">
        <p className="fc-state fc-state--warn"><span className="fc-state-dot" aria-hidden="true" />{t('fc.br.elsewhere')}</p>
        {Number.isFinite(seenAt) && seenAt > 0 && <p className="fc-muted">{t('fc.br.seen')} {tarikhMasaPapar(seenAt, lang)}</p>}
        <div className="fc-actions">
            <Btn disabled={busy} onClick={onMove}>{busy && <span className="fc-spinner" aria-hidden="true" />}{busy ? t('fc.br.moving') : t('fc.br.move')}</Btn>
        </div>
        <p className="fc-muted">{t('fc.br.note')}</p>
    </div>;
}
